export default __webpack_public_path__ + "static/media/fishtwo.171cf161.png";